import { Game } from '../srm/srm-parser'

function TimeSection({
  time,
  onUpdate
}: {
  time: Game['time']
  onUpdate: (field: 'hours' | 'minutes', value: number) => void
}) {
  return (
    <div className="card-section">
      <h3 className="section-title">Time</h3>
      <div className="time-inputs">
        <label className="input-label">
          <span>Hours</span>
          <input
            className="num-input"
            type="number"
            min={0}
            value={time.hours.dec}
            onChange={(e) =>
              onUpdate('hours', Math.max(0, parseInt(e.target.value) || 0))
            }
          />
        </label>
        <span className="time-sep">:</span>
        <label className="input-label">
          <span>Min</span>
          <input
            className="num-input"
            type="number"
            min={0}
            max={59}
            value={time.minutes.dec}
            onChange={(e) =>
              onUpdate(
                'minutes',
                Math.min(59, Math.max(0, parseInt(e.target.value) || 0))
              )
            }
          />
        </label>
      </div>
    </div>
  )
}

export default TimeSection
